export const GET_APPOINTMENT = "GET_APPOINTMENT";
export const GET_APPOINTMENT_SUCCESS = "GET_APPOINTMENT_SUCCESS";
export const GET_APPOINTMENT_ERROR = "GET_APPOINTMENT_ERROR";
export const GET_APPOINTMENT_CLEAR_DATA = "GET_APPOINTMENT_CLEAR_DATA";

//AppointmentAction
export const GET_APPOINTMENT_ACTION = "GET_APPOINTMENT_ACTION";
export const GET_APPOINTMENT_ACTION_SUCCESS = "GET_APPOINTMENT_ACTION_SUCCESS";
export const GET_APPOINTMENT_ACTION_ERROR = "GET_APPOINTMENT_ACTION_ERROR";
export const GET_APPOINTMENT_ACTION_CLEAR_DATA =
  "GET_APPOINTMENT_ACTION_CLEAR_DATA";

export const APPOINTMENTACTION_PATCH = "APPOINTMENTACTION_PATCH";
export const APPOINTMENTACTION_PATCH_SUCCESS =
  "APPOINTMENTACTION_PATCH_SUCCESS";
export const APPOINTMENTACTION_PATCH_ERROR = "APPOINTMENTACTION_PATCH_ERROR";
export const APPOINTMENTACTION_PATCH_CLEAR_DATA =
  "APPOINTMENTACTION_PATCH_CLEAR_DATA";

export const EXECUTIVELIST_GET = "EXECUTIVELIST_GET";
export const EXECUTIVELIST_GET_SUCCESS = "EXECUTIVELIST_GET_SUCCESS";
export const EXECUTIVELIST_GET_ERROR = "EXECUTIVELIST_GET_ERROR";
export const EXECUTIVELIST_GET_CLEAR_DATA = "EXECUTIVELIST_GET_CLEAR_DATA";

export const APPOINTMENTAVAILABILITY_POST = "PPOINTMENTAVAILABILITY_POST";
export const APPOINTMENTAVAILABILITY_POST_SUCCESS =
  "APPOINTMENTAVAILABILITY_POST_SUCCESS";
export const APPOINTMENTAVAILABILITY_POST_ERROR =
  "APPOINTMENTAVAILABILITY_POST_ERROR";
export const APPOINTMENTAVAILABILITY_POST_CLEAR_DATA =
  "APPOINTMENTAVAILABILITY_POST_CLEAR_DATA";

export const APPOINTMENT_POST = "GET_APPOINTMENT_POST";
export const APPOINTMENT_POST_SUCCESS = "APPOINTMENT_POST_SUCCESS";
export const APPOINTMENT_POST_ERROR = "APPOINTMENT_POST_ERROR";
export const APPOINTMENT_POST_CLEAR_DATA = "APPOINTMENT_POST_CLEAR_DATA";
